import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { EarningsHiddenReason } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { streamingEarningsMessages as messages } from '../streamingEarningsMessages';
import { Panel } from '../../components/primitives/Panel';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { StreamingPlanLockCard } from './StreamingPlanLockCard';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface EarningsHiddenCardProps {
  /** Why the API sent no amount. Absent from an old server: then the member card. */
  reason?: EarningsHiddenReason;
}

/**
 * The card when the API sends no amount. `reason: 'plan'` (Free): the plan card, which opens the
 * upgrade prompt. Else the quiet card of a member when the owner keeps earnings private
 * (design e2). The card has no number to hide.
 */
const EarningsHiddenCardComponent: React.FC<EarningsHiddenCardProps> = ({ reason }) => {
  const intl = useIntl();
  if (reason === 'plan') {
    return (
      <StreamingPlanLockCard
        feature={SMLUpgradeFeature.earnings}
        title={messages.planTitle}
        testId="streaming-earnings-plan-lock"
      />
    );
  }
  return (
    <Panel nested className={styles.card} data-testid="streaming-earnings-hidden">
      <span className={styles.lockChip}>
        <FontAwesomeIcon icon={faLock} />
      </span>
      <h3>{intl.formatMessage(messages.hiddenTitle)}</h3>
      <p>{intl.formatMessage(messages.hiddenText)}</p>
      <p className={styles.faint}>{intl.formatMessage(messages.hiddenHint)}</p>
    </Panel>
  );
};

export const EarningsHiddenCard = TypedMemo(EarningsHiddenCardComponent);
